module.exports = __webpack_public_path__ + "img/services.4dbd4350.svg";